// @ts-nocheck
import React, { MouseEvent, useEffect, useRef, useState } from 'react';
import '../../../styles/Sidebar.css';
import {
	Alert,
	Button,
	Checkbox,
	CircularProgress,
	Divider,
	Fade,
	IconButton,
	Link,
	Menu,
	MenuItem,
	Tab,
	Tabs,
	TextField,
	Typography,
	Zoom,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CompanyLogo from '../../../../public/company_logo.jpg';
import ChatListItem from '@src/components/ChatListItem';
import {
	containsLetters,
	getBaseRoute,
	generateErrorMessage,
	generateInitialsHelper,
	isScrollable,
} from '@src/helpers/Helpers';
import {
	CHAT_KEY_PREFIX,
	CHAT_LIST_TAB_CASE_ALL,
	CHAT_LIST_TAB_CASE_GROUP,
	CHAT_LIST_TAB_CASE_ME,
	CHAT_LIST_TAB_CASE_SPAM,
	EVENT_TOPIC_CHAT_ASSIGNMENT,
	EVENT_TOPIC_GO_TO_MSG_ID,
	EVENT_TOPIC_NEW_CHAT_MESSAGES,
	EVENT_TOPIC_UPDATE_PERSON_NAME,
	RESTAURANT,
} from '@src/Constants';
import { useNavigate, useParams } from 'react-router-dom';
import SearchBar from '../../SearchBar';
import SidebarContactResult from './SidebarContactResult';
import ChatModel from '../../../api/models/ChatModel';
import NewMessageModel from '../../../api/models/NewMessageModel';
import PubSub from 'pubsub-js';
import BusinessProfile from './BusinessProfile';
import ChangePasswordDialog from './ChangePasswordDialog';
import ChatMessageModel from '../../../api/models/ChatMessageModel';
import SearchMessageResult from '../../SearchMessageResult';
import { isMobile, isMobileOnly } from 'react-device-detect';
import ChatIcon from '@mui/icons-material/Chat';
import StartChat from '../../StartChat';
import { clearContactProvidersData } from '@src/helpers/StorageHelper';
import CloseIcon from '@mui/icons-material/Close';
import BulkSendIndicator from './BulkSendIndicator';
import SelectableChatTag from './SelectableChatTag';
import BulkSendActions from './BulkSendActions';
import { clearUserSession, generateCancelToken } from '@src/helpers/ApiHelper';
import Notifications from './Notifications/Notifications';
import { Add, Notifications as NotificationsIcon } from '@mui/icons-material';
import { getObjLength } from '@src/helpers/ObjectHelper';
import { getBaseURL, getHubURL } from '@src/helpers/URLHelper';
import RetryFailedMessages from './RetryFailedMessages';
import UploadMediaIndicator from './UploadMediaIndicator';
import { Trans, useTranslation } from 'react-i18next';
import { AppConfig } from '@src/contexts/AppConfig';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import { filterChat } from '@src/helpers/SidebarHelper';
import { setCurrentUser, setPermissions } from '@src/store/reducers/currentUserReducer';
import { setTemplates } from '@src/store/reducers/templatesReducer';
import ChatsResponse from '../../../api/responses/ChatsResponse';
import { setFilterTag } from '@src/store/reducers/filterTagReducer';
import { setChatsCount } from '@src/store/reducers/chatsCountReducer';
import ChatTag from '../../ChatTag';
import CustomAvatar from '@src/components/CustomAvatar';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import styles from '@src/components/Main/Sidebar/Sidebar.module.css';
import SellIcon from '@mui/icons-material/Sell';
import { AxiosError, AxiosResponse, CancelTokenSource } from 'axios';
import ChatMessageList from '@src/interfaces/ChatMessageList';
import { addChats, setChats } from '@src/store/reducers/chatsReducer';
import CustomModal from '@src/components/CustomModal/CustomModal';
import {
	addContactGetChat,
	getHiddenContacts,
	updateContactDetailsGetChat,
	updateHiddenContacts,
} from '@src/api/SudoApiService';
import PhoneNumberField from '@src/components/InputField/PhoneNumberField';
import { useDispatch } from 'react-redux';
import FileUploader from '@src/components/FileUpload/FileUpload';
import CustomAlert from '@src/components/CustomAlert/CustomAlert';
import ProgressBar from '@src/components/ProgressBar/ProgressBar';
import CustomDialog from '@src/components/CustomDialog/CustomDialog';
import SwitchAccessShortcutIcon from '@mui/icons-material/SwitchAccessShortcut';
import { styled } from 'styled-components';
import { LockIcon, LogoutIcon, MenuIcon } from '@src/components/Icons';
import { setToggleMenu } from '@src/store/reducers/UIReducer';
import { IsMobileWidth } from '../../MediaQueryUtils/index.ts';
import { addPlus } from '@src/helpers/PhoneNumberHelper';
import { setSupplierCatalog } from '@src/store/reducers/catalogReducer';
import { setAllOrders } from '@src/store/reducers/orderReducer';
import { setCart } from '@src/store/reducers/cartReducer';
import { setBranches, setRestaurants } from '@src/store/reducers/branchReducer';
import { setAllUsers } from '@src/store/reducers/teamReducer';
import CustomTooltip from '@src/components/CustomTootip/CustomTooltip';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import CustomPermission from '@src/components/Permissions/CustomPermission';
import Loading from '@src/components/Loading/Loading';
import OrganizationSwitcher from '@src/components/Switcher/OrganizationSwitcher';
import AvatarMenu from '@src/components/CustomAvatar/AvatarMenu';
import SlidableDrawer from '@src/components/CustomModal/SlidableDrawer';

const SidebarHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: #ffbe00;
	height: 100px;
	padding: 16px;
`;

const StyledSeparator = styled.div`
	height: 55px;
	padding-left: 16px;
	display: flex;
	align-items: center;
`;

const Sidebar: React.FC = ({
	pendingMessages,
	setPendingMessages,
	isSendingPendingMessages,
	hasFailedMessages,
	lastSendAttemptAt,
	isUploadingMedia,
	newMessages,
	setNewMessages,
	setProgress,
	displayNotification,
	isBlurred,
	contactProvidersData,
	retrieveContactData,
	isChatOnly,
	setChatTagsListVisible,
	isSelectionModeEnabled,
	setSelectionModeEnabled,
	bulkSendPayload,
	selectedChats,
	setSelectedChats,
	selectedTags,
	setSelectedTags,
	finishBulkSendMessage,
	setLoadingNow,
	setUploadRecipientsCSVVisible,
	setBulkSendTemplateDialogVisible,
	setBulkSendTemplateViaCSVVisible,
	setBulkSendTemplateWithCallbackDialogVisible,
	setInitialResourceFailed,
	setSendBulkVoiceMessageDialogVisible,
	chatId,
	setChatId,
	setShowTagsManagement,
	restaurantId,
	setFieldBackField,
	permissionLoader,
}) => {
	// @ts-ignore
	const { apiService } = React.useContext(ApplicationContext);
	const config = React.useContext(AppConfig);

	const chats = useAppSelector((state) => state.chats.value);
	const tags = useAppSelector((state) => state.tags.value);
	const currentUser = useAppSelector((state) => state.currentUser.value);
	const filterTag = useAppSelector((state) => state.filterTag.value);
	const chatsCount = useAppSelector((state) => state.chatsCount.value);
	const pullToRefresh: any = useAppSelector((state) => state?.UI?.pullToRefresh);
	const isRestaurant = currentUser?.type?.toLowerCase() === RESTAURANT;
	//Permissions
	const checkPermission = usePermission();
	const canViewChat = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.CHAT?.VIEW, waId);
	const canCreateChat = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.CHAT?.CREATE, waId);

	const { t } = useTranslation();

	const { waId, id } = useParams();
	const chatsContainer = useRef(null);
	let chatsArray = Object.entries(chats);

	const [anchorEl, setAnchorEl] = useState<(EventTarget & Element) | null>(null);
	const [bulkMessageMenuAnchorEl, setBulkMessageMenuAnchorEl] = useState<
		(EventTarget & Element) | null
	>(null);
	const [keyword, setKeyword] = useState('');
	const [contactAdded, setContactAdded] = useState(false);
	const [searchedKeyword, setSearchedKeyword] = useState('');
	const [chatMessages, setChatMessages] = useState({});
	const [contactResults, setContactResults] = useState({});
	const [isProfileVisible, setProfileVisible] = useState(false);
	const [isContactsVisible, setContactsVisible] = useState(false);
	const [isChangePasswordDialogVisible, setChangePasswordDialogVisible] = useState(false);
	const [isNotificationsVisible, setNotificationsVisible] = useState(false);
	const [isLoadingChats, setLoadingChats] = useState(false);
	const [isLoadingMoreChats, setLoadingMoreChats] = useState(false);
	const [isLoading, setLoading] = useState(!chatsArray?.length);
	const [tabCase, setTabCase] = useState(CHAT_LIST_TAB_CASE_ALL);
	const [error, setError] = useState({ message: '', severity: '' });
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [fileProgress, setFileProgress] = useState<Number>(10);
	const [disable, setDisable] = useState(false);
	const [hideChatOption, setHideChatOption] = useState<Boolean>(false);
	const [unhideChatOption, setUnhideChatOption] = useState(false);
	const [selectAll, setSelectAll] = useState(false);
	const [tempSpamChats, setTempSpamChats] = useState([]);
	const [tempUnSpamChats, setTempUnSpamChats] = useState([]);
	const [spamChats, setSpamChats] = useState([]);
	const [confirmDialog, setConfirmDialog] = useState();
	const [tabChangeLoading, setTabChangeLoading] = useState(true);

	const [missingChats, setMissingChats] = useState<string[]>([]);
	const [missingRestaurant, setMissingRestaurant] = useState<string[]>([]);

	const [addContactModal, setAddContactModal] = useState(false);

	const timer = useRef<NodeJS.Timeout>();

	const navigate = useNavigate();

	const dispatch = useAppDispatch();
	const isMobileWidth = IsMobileWidth();

	const logOut = () => {
		clearUserSession(undefined, undefined, navigate, () => apiService.logoutCallV2());
		hideMenu();
	};

	const spamChat = (chat, allSpamChats) => {
		if (!selectAll) {
			allSpamChats.push(chat[1]?.waId);
		} else {
			allSpamChats = [];
		}
		return allSpamChats;
	};

	const handleFileRead = (event: ProgressEvent<FileReader>) => {
		const csvData = event.target?.result;
		if (typeof csvData === 'string') {
			const jsonData = convertCsvToJson(csvData);
			createBulkChat(jsonData);
		}
	};

	const convertCsvToJson = (csvData: string) => {
		const lines = csvData.split('\n');
		const headers = lines[0].split(',');
		const requestedHeader = {
			name: false,
			number: false,
		};
		const res = headers?.map((header) => {
			if (header?.toLowerCase()?.trim() === 'name') {
				requestedHeader['name'] = true;
			} else if (header?.toLowerCase()?.trim() === 'number') {
				requestedHeader['number'] = true;
			}
		});
		if (requestedHeader['number'] && requestedHeader['name']) {
			const jsonData: any[] = [];

			for (let i = 1; i < lines.length; i++) {
				const line = lines[i].split(',');
				if (line.length >= 2) {
					const handle = line[0].trim();
					const phone_number = line[1].trim();
					jsonData.push({ handle, phone_number });
				}
			}
			return jsonData;
		} else {
			setError('The CSV file does not contain the requested headers');
		}
	};

	const forceClearContactProvidersData = () => {
		clearContactProvidersData();
		window.location.reload();
	};

	const displayMenu = (event: MouseEvent) => {
		setAnchorEl(event.currentTarget);
	};

	const hideMenu = () => {
		setAnchorEl(null);
	};

	const handleNo = () => {
		setConfirmDialog(false);
	};

	const handleYes = async () => {
		try {
			if (tabCase !== 'spam') {
				setLoadingChats(true);
				setDisable(true);
				const data = {
					contacts: [...tempSpamChats],
					hidden: true,
				};
				await updateHiddenContacts(data);
				setContactAdded(true);
				setConfirmDialog(false);
				setTempSpamChats([]);
				setSelectAll(false);
				setLoadingChats(false);
				setDisable(false);
			} else {
				setLoadingChats(true);
				setDisable(true);
				const data = {
					contacts: [...tempUnSpamChats],
					hidden: false,
				};
				await updateHiddenContacts(data);
				setContactAdded(true);
				setTempUnSpamChats([]);
				setConfirmDialog(false);
				setLoadingChats(false);
				setDisable(false);
			}
		} catch (err) {
			setError('Something went wrong! please try agin');
			setLoadingChats(false);
			setDisable(false);
		}
	};

	let cancelTokenSourceRef = useRef<CancelTokenSource | undefined>();

	useEffect(() => {
		if (canViewChat) {
			// Generate a token
			cancelTokenSourceRef.current = generateCancelToken();

			timer.current = setTimeout(async () => {
				listChats(cancelTokenSourceRef.current, true, undefined, true);

				// if (keyword.trim().length > 0) {
				// 	searchMessages(cancelTokenSourceRef.current);
				// }

				setSearchedKeyword(keyword);
			}, 300);

			if (contactAdded) {
				setContactAdded(false);
			}

			return () => {
				if (cancelTokenSourceRef.current) {
					cancelTokenSourceRef.current.cancel('Operation canceled due to new request.');
				}

				clearTimeout(timer.current);
			};
		} else {
			setProgress(100);
			setLoading(false);
		}
	}, [keyword, tabCase, filterTag, contactAdded, canViewChat, pullToRefresh]);

	useEffect(() => {
		// New chatMessages
		const onNewMessages = function (msg: string, data: ChatMessageList) {
			// We don't need to update if chats are filtered
			if (keyword.trim().length === 0) {
				let newMissingChats: string[] = [];
				const nextState = { ...chats };
				let changedAny = false;

				Object.entries(data).forEach((message) => {
					//const msgId = message[0];

					const chatMessage = message[1];
					const chatMessageWaId = chatMessage.waId;

					const chatKey = generateChatId(chatMessageWaId);

					// New chat, incoming or outgoing message
					// Check if chat with waId already exists
					if (!nextState.hasOwnProperty(chatKey)) {
						// Collect waId list to retrieve chats
						if (!newMissingChats?.includes(chatMessageWaId)) {
							newMissingChats.push(chatMessageWaId);
						}
					}

					// Chats are ordered by incoming message date
					if (nextState.hasOwnProperty(chatKey)) {
						changedAny = true;

						// Update existing chat
						nextState[chatKey].setLastMessage(chatMessage.payload);

						// Incoming
						if (!chatMessage.isFromUs) {
							// Update name and initials on incoming message if name is missing
							const chat = nextState[chatKey];
							if (chat) {
								const chatName = chat.name;
								if (!containsLetters(chatName)) {
									// Update sidebar chat name
									nextState[chatKey].setName(chatMessage.senderName);

									// Check if current chat
									if (waId === chatMessageWaId) {
										PubSub.publish(EVENT_TOPIC_UPDATE_PERSON_NAME, chatMessage.senderName);
									}
								}
							}
						}
					}

					// New chatMessages
					if (
						!chatMessage.isFromUs &&
						(waId !== chatMessageWaId || document.visibilityState === 'hidden' || isBlurred)
					) {
						const preparedNewMessages = newMessages;

						if (newMessages[CHAT_KEY_PREFIX + chatMessageWaId] === undefined) {
							setMissingRestaurant(restaurantId);
							preparedNewMessages[CHAT_KEY_PREFIX + chatMessageWaId] = new NewMessageModel(
								chatMessageWaId,
								0,
								restaurantId
							);
						}

						//if chat already open dont increase
						if (chatMessageWaId === waId) {
							return;
						}
						// Increase number of new chatMessages
						preparedNewMessages[CHAT_KEY_PREFIX + chatMessageWaId].newMessages++;
						setNewMessages({ ...preparedNewMessages });

						// Display a notification
						if (!chatMessage.isFromUs) {
							displayNotification(t('New messages'), t('You have new messages!'), chatMessageWaId);
						}
						return;
					}
				});

				// If anything has changed, sort chats
				if (changedAny) {
					// Sorting
					const sortedNextState = sortChats(nextState);
					dispatch(setChats({ ...sortedNextState }));
				}

				// Collect missing chats to load them periodically
				if (newMissingChats.length > 0) {
					setMissingChats((prevState) => {
						let nextState = prevState.concat(newMissingChats);

						// Unique wa ids
						return [...new Set(nextState)];
					});
				}
			}
		};

		const newChatMessagesEventToken = PubSub.subscribe(
			EVENT_TOPIC_NEW_CHAT_MESSAGES,
			onNewMessages
		);

		return () => {
			PubSub.unsubscribe(newChatMessagesEventToken);
		};
	}, [waId, isBlurred, chats, newMessages, missingChats, keyword]);

	const generateChatId = (waId) => {
		// if (currentUser?.type?.toLowerCase() !== RESTAURANT) {
		// 	return CHAT_KEY_PREFIX + id + waId;
		// }
		return CHAT_KEY_PREFIX + waId;
	};

	useEffect(() => {
		const onChatAssignment = function (msg: string, data: any) {
			let newMissingChats: string[] = [];
			const nextState = { ...chats };

			Object.entries(data).forEach((message) => {
				//const msgId = message[0];
				const assignmentData = message[1];
				const assignmentEvent = assignmentData.assignmentEvent;

				if (assignmentEvent) {
					const chatKey = generateChatId(assignmentData.waId);

					if (assignmentEvent.assigned_group_set || assignmentEvent.assigned_to_user_set) {
						// Check if chat exists and is loaded
						if (!nextState.hasOwnProperty(chatKey)) {
							// Collect waId list to retrieve chats
							if (!newMissingChats?.includes(assignmentData.waId)) {
								newMissingChats.push(assignmentData.waId);
							}
						}
					}
				}
			});

			if (newMissingChats.length > 0) {
				setMissingChats((prevState) => {
					let nextState = prevState.concat(newMissingChats);

					// Unique wa ids
					return [...new Set(nextState)];
				});
			}
		};

		const chatAssignmentEventToken = PubSub.subscribe(
			EVENT_TOPIC_CHAT_ASSIGNMENT,
			onChatAssignment
		);

		return () => {
			PubSub.unsubscribe(chatAssignmentEventToken);
		};
	}, [chats, missingChats]);

	useEffect(() => {
		let intervalId = setInterval(function () {
			if (missingChats?.length > 0) {
				missingChats.forEach((chatMessageWaId) => {
					console.log(
						`A new message is received from ${chatMessageWaId} but this chat is not loaded yet. Retrieving chat via API.`
					);
					//when waId from param not matches the chatmesgWaid
					// if (waId && waId !== chatMessageWaId) {
					// 	clearInterval(intervalId);
					// 	return;
					// }
					//take id from param in restaurant case
					retrieveChat(chatMessageWaId, id || restaurantId);
				});
			}
		}, 2000);

		return () => {
			clearInterval(intervalId);
		};
	}, [missingChats]);

	useEffect(() => {
		const chatsContainerCopy = chatsContainer.current;

		// To optimize scroll event
		let debounceTimer;

		function handleScroll(e) {
			if (debounceTimer) {
				window.clearTimeout(debounceTimer);
			}

			// if (keyword) {
			// 	window.clearTimeout(debounceTimer);
			// 	return false;
			// }

			debounceTimer = setTimeout(async function () {
				// const threshold = 0;
				const el = e.target;

				if (isScrollable(el)) {
					if (el.scrollHeight - el.scrollTop - el.clientHeight < 1) {
						listChats(cancelTokenSourceRef.current, false, getObjLength(chats), false);
					}
				}
			}, 100);
		}

		chatsContainerCopy.addEventListener('scroll', handleScroll);

		return () => {
			clearTimeout(debounceTimer);
			chatsContainerCopy.removeEventListener('scroll', handleScroll);
		};
	}, [chats, keyword, filterTag]);

	const search = async (_keyword) => {
		setLoading(true);
		setKeyword(_keyword);
	};

	useEffect(() => {
		if (isSelectionModeEnabled) {
			setContactsVisible(false);
		}
	}, [isSelectionModeEnabled]);

	const sortChats = (state) => {
		let sortedState = Object.entries(state).sort((a, b) => {
			const timestampA = a[1].lastMessageTimestamp || 0;
			const timestampB = b[1].lastMessageTimestamp || 0;

			return timestampB - timestampA;
		});

		return Object.fromEntries(sortedState);
	};

	const listChats = (cancelTokenSource, isInitial, offset, replaceAll) => {
		if (!isInitial) {
			setLoadingMoreChats(true);
		} else {
			setLoadingNow('Chats');
		}

		// Reset chats count
		dispatch(setChatsCount(undefined));

		if (replaceAll) {
			setLoadingChats(true);
		}

		const assignedToMe = tabCase === CHAT_LIST_TAB_CASE_ME ? true : undefined;
		const assignedGroup = tabCase === CHAT_LIST_TAB_CASE_GROUP ? true : undefined;

		apiService.listChatsCallV2(
			keyword,
			filterTag?.id,
			20,
			offset,
			assignedToMe,
			assignedGroup,
			cancelTokenSource.token,
			(response) => {
				const data = response?.data?.data;
				const chatsResponse = new ChatsResponse(data);

				dispatch(setChatsCount(chatsResponse.count));
				const sortedChats = sortChats(chatsResponse.chats);

				setLoading(false);

				// Store
				if (replaceAll) {
					dispatch(setChats(sortedChats));
				} else {
					dispatch(addChats(sortedChats));
				}

				// In case param is undefined
				isInitial = isInitial === true;

				if (isInitial) {
					setProgress(100);
				}

				const willNotify = !isInitial;

				let newMessageExist = false;
				const preparedNewMessages = {};
				data?.results?.forEach((newMessage) => {
					const newWaId = newMessage.contact.waba_payload.wa_id;
					const restaurantId = newMessage?.contact?.waba_payload?.profile?.restaurantId || '';
					const newAmount = newMessage?.new_messages;
					const prepared = new NewMessageModel(newWaId, newAmount, restaurantId);

					preparedNewMessages[generateChatId(newWaId)] = prepared;
				});

				if (willNotify) {
					let hasAnyNewMessages = false;
					let chatMessageWaId;

					setNewMessages((prevState) => {
						Object.entries(preparedNewMessages).forEach((newMsg) => {
							console.warn({ preparedNewMessages });
							const newMsgWaId = newMsg[0];
							const number = newMsg[1].newMessages;
							if (newMsgWaId !== waId) {
								// TODO: Consider a new contact (last part of the condition)
								if (
									prevState[newMsgWaId] &&
									number >
										prevState[newMsgWaId].newMessages /*|| (!prevState[newMsgWaId] && number > 0)*/
								) {
									hasAnyNewMessages = true;

									// There can be multiple new chats, we take first one
									if (chatMessageWaId === newMsgWaId) chatMessageWaId = newMsgWaId;
								}
							}
						});

						// When state is a JSON object, it is unable to understand whether it is different or same and renders again
						// So we check if new state is actually different than previous state
						if (JSON.stringify(preparedNewMessages) !== JSON.stringify(prevState)) {
							return { ...prevState, ...preparedNewMessages };
						} else {
							return prevState;
						}
					});

					// Display a notification
					if (hasAnyNewMessages) {
						displayNotification(t('New messages'), t('You have new messages!'), chatMessageWaId);
					}
				} else {
					setNewMessages((prevState) => {
						return { ...prevState, ...preparedNewMessages };
					});
				}
				setLoadingMoreChats(false);
				setLoadingChats(false);
			},
			(error) => {
				setLoadingMoreChats(false);
				setLoadingChats(false);
				setLoading(false);

				if (isInitial) {
					setInitialResourceFailed(true);
				}

				if (!navigator?.onLine) {
					dispatch(setChats(chats));
					setProgress(100);
				}
			},
			navigate,
			id
		);
	};

	const retrieveChat = (chatWaId, id) => {
		if (canViewChat) {
			apiService.retrieveChatCallV2(
				chatWaId,
				undefined,
				(response: AxiosResponse) => {
					// Remove this chat from missing chats list
					setMissingChats((prevState) => prevState.filter((item) => item !== chatWaId));
					const preparedChat = new ChatModel(response.data.data);

					// Don't display chat if tab case is "me" and chat is not assigned to user
					if (tabCase === CHAT_LIST_TAB_CASE_ME) {
						if (
							!preparedChat.assignedToUser ||
							preparedChat.assignedToUser.id !== currentUser?.id
						) {
							console.log('Chat will not be displayed as it does not belong to current tab.');
							return;
						}
					} else if (tabCase === CHAT_LIST_TAB_CASE_GROUP) {
						if (
							!preparedChat.assignedGroup ||
							currentUser?.isInGroup(preparedChat.assignedGroup.id)
						) {
							console.log('Chat will not be displayed as it does not belong to current tab.');
							return;
						}
					}

					const prevState = { ...chats };
					prevState[generateChatId(chatWaId)] = preparedChat;
					const sortedNextState = sortChats(prevState);

					dispatch(setChats({ ...sortedNextState }));
				},
				(error: AxiosError) => console.log(error),
				id
			);
		}
	};

	const goToMessage = (chatMessage) => {
		console.log(chatMessage);
		if (waId !== chatMessage.waId) {
			navigate(`/${getBaseRoute(currentUser?.type)}/${id}/chat/${chatMessage.waId}`, {
				state: {
					goToMessage: chatMessage,
				},
			});
		} else {
			PubSub.publish(EVENT_TOPIC_GO_TO_MSG_ID, chatMessage);
		}
	};

	const setSpamChatsInitialValues = () => {
		dispatch(addChats([]));
		setTempSpamChats([]);
		setTempUnSpamChats([]);
		setUnhideChatOption(false);
		setHideChatOption(false);
		setSelectAll(false);
		setTabChangeLoading(true);
	};

	const cancelSelection = () => {
		setSelectionModeEnabled(false);
		setSelectedChats([]);
		setSelectedTags([]);
	};

	const handleFinishBulkSendMessage = () => {
		setSelectionModeEnabled(false);
		finishBulkSendMessage();
	};

	const displayNotifications = () => {
		setNotificationsVisible(true);
	};

	const createBulkChat = async (chats: { handle: string; phone_number: string }[]) => {
		const $ChatPromises = [];
		// chats?.forEach(async(chat) => {
		// 	$ChatPromises.push(addContactGetChat(chat));
		// });
		for (const chat of chats) {
			try {
				if (chat?.phone_number[0] !== '+') {
					chat.phone_number = `+${chat.phone_number}`;
				}
				const response = await addContactGetChat(chat);
			} catch (error) {
				continue;
			}
		}
		setContactAdded(true);

		// await Promise.allSettled($ChatPromises).then((results) => {
		// 	console.log(results);
		// 	let rejectedPromised = [];
		// 	results?.forEach((result, index) => {
		// 		if (result?.status === 'rejected') {
		// 			rejectedPromised?.push(index + 1);
		// 		}
		// 	});
		// 	setContactAdded(true);
		// 	if (rejectedPromised?.length) {
		// 		setError(
		// 			`Invalid phone numbers found in rows ${rejectedPromised?.join(
		// 				','
		// 			)}. Please use the valid syntax format: +92335201234`
		// 		);
		// 	}
		// });
	};

	return (
		<>
			{confirmDialog ? (
				<CustomDialog
					open={confirmDialog}
					setConfirmModal={setConfirmDialog}
					disable={disable}
					description={`Are you sure you want to ${
						tabCase !== 'spam' ? 'hide' : 'unhide'
					} this chat`}
					handleClose={handleNo}
					handleYes={handleYes}
				/>
			) : null}
			{error?.message ? <CustomAlert alert={error} setAlert={setError} /> : null}
			{addContactModal ? (
				<CustomModal
					open={addContactModal}
					setOpen={setAddContactModal}
					children={
						<AddContactForm
							setModal={setAddContactModal}
							setContactAdded={setContactAdded}
							setKeyword={setKeyword}
							setSearchedKeyword={setSearchedKeyword}
						/>
					}
				/>
			) : null}
			<div className={'sidebar' + (isChatOnly ? ' hidden' : '')}>
				
					<div className="sidebar__header">
						{isMobileWidth ? (
							<IconButton
								onClick={() => {
									dispatch(setToggleMenu(true));
								}}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						) : null}
						<div className="sidebar__headerLeft">
							<CustomAvatar
								src={currentUser?.profile}
								onClick={() =>
									navigate(`/${getBaseRoute(currentUser?.type)}/${id}/settings/general`)
								}
								className="cursorPointer"
								generateBgColorBy={currentUser?.firstName}
							>
								{currentUser ? generateInitialsHelper(currentUser?.firstName) : ''}
							</CustomAvatar>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									marginTop: '2px',
								}}
							>
								<Typography sx={{ pl: 2 }} variant="chatFont">
									{currentUser?.firstName}
								</Typography>
								<span
									style={{
										fontSize: '11px',
										color: 'rgba(0, 0, 45, 0.45)',
										paddingLeft: '16px',
									}}
								>
									{addPlus(currentUser?.phone)}
								</span>
							</div>
						</div>

						<div className="sidebar__headerRight">
							<CustomTooltip title={t('Options')}>
								<IconButton onClick={displayMenu} data-test-id="options" size="large">
									<MoreVertIcon />
								</IconButton>
							</CustomTooltip>
						</div>
					</div>
			
					{/* <SidebarHeader>
						{isRestaurant ? <OrganizationSwitcher /> : null}
						{isRestaurant ? (
							<AvatarMenu />
						) : (
							<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
								<AvatarMenu />
							</div>
						)}
					</SidebarHeader> */}
				

				{isSelectionModeEnabled && (
					<BulkSendActions
						selectedChats={selectedChats}
						setSelectedChats={setSelectedChats}
						selectedTags={selectedTags}
						cancelSelection={cancelSelection}
						finishBulkSendMessage={handleFinishBulkSendMessage}
						setUploadRecipientsCSVVisible={setUploadRecipientsCSVVisible}
					/>
				)}

				<div className={styles.searchContainer}>
					<SearchBar value={keyword} onChange={(_keyword) => search(_keyword)} />
				</div>

				<div className="sidebar__results" ref={chatsContainer}>
					{isSelectionModeEnabled &&
						tags &&
						bulkSendPayload?.type === ChatMessageModel.TYPE_TEMPLATE && (
							<>
								<h3>{t('Tags')}</h3>
								<div>
									{Object.entries(tags).map((tag) => (
										<SelectableChatTag
											key={tag[0]}
											data={tag[1]}
											selectedTags={selectedTags}
											setSelectedTags={setSelectedTags}
										/>
									))}
								</div>
							</>
						)}
					{!isLoading && !permissionLoader ? (
						canViewChat ? (
							<>
								{(searchedKeyword.trim().length > 0 || isSelectionModeEnabled) && (
									<h3>{t('Chats')}</h3>
								)}
								<div className="sidebar__results__chats">
									{chatsArray
										?.filter((chat) => chat[1]?.lastMessage)
										?.map((chat) => {
											return (
												<ChatListItem
													key={chat[0]}
													chatData={chat[1]}
													pendingMessages={pendingMessages}
													restaurantId={chat[1].restaurantId}
													newMessages={newMessages}
													setNewMessages={setNewMessages}
													keyword={searchedKeyword}
													contactProvidersData={contactProvidersData}
													retrieveContactData={retrieveContactData}
													tabCase={tabCase}
													bulkSendPayload={bulkSendPayload}
													isSelectionModeEnabled={isSelectionModeEnabled}
													selectedChats={selectedChats}
													setSelectedChats={setSelectedChats}
													chats={chats}
													hideChatOption={hideChatOption}
													unhideChatOption={unhideChatOption}
													selectAll={selectAll}
													setSelectAll={setSelectAll}
													tempSpamChats={tempSpamChats}
													setTempSpamChats={setTempSpamChats}
													tempUnSpamChats={tempUnSpamChats}
													setTempUnSpamChats={setTempUnSpamChats}
													spamChats={spamChats}
													setSpamChats={setSpamChats}
													setError={setError}
													setLoadingChats={setLoadingChats}
													setChatId={setChatId}
													setFieldBackField={setFieldBackField}
												/>
											);
										})}

									{chatsArray?.filter((chat) => chat[1]?.lastMessage)?.length &&
									chatsArray?.filter((chat) => !chat[1]?.lastMessage)?.length &&
									canCreateChat &&
									isRestaurant ? (
										<StyledSeparator className="default-lighter-text">
											<Typography variant="body3">Other Suppliers</Typography>
										</StyledSeparator>
									) : null}
									{canCreateChat &&
										chatsArray
											?.sort((a, b) =>
												a[1]?.name?.toLowerCase()?.localeCompare(b[1]?.name.toLowerCase())
											)
											?.filter((chat) => !chat[1]?.lastMessage)
											?.map((chat) => {
												return (
													<ChatListItem
														key={chat[0]}
														chatData={chat[1]}
														pendingMessages={pendingMessages}
														restaurantId={chat[1].restaurantId}
														newMessages={newMessages}
														setNewMessages={setNewMessages}
														keyword={searchedKeyword}
														contactProvidersData={contactProvidersData}
														retrieveContactData={retrieveContactData}
														tabCase={tabCase}
														bulkSendPayload={bulkSendPayload}
														isSelectionModeEnabled={isSelectionModeEnabled}
														selectedChats={selectedChats}
														setSelectedChats={setSelectedChats}
														chats={chats}
														hideChatOption={hideChatOption}
														unhideChatOption={unhideChatOption}
														selectAll={selectAll}
														setSelectAll={setSelectAll}
														tempSpamChats={tempSpamChats}
														setTempSpamChats={setTempSpamChats}
														tempUnSpamChats={tempUnSpamChats}
														setTempUnSpamChats={setTempUnSpamChats}
														spamChats={spamChats}
														setSpamChats={setSpamChats}
														setError={setError}
														setLoadingChats={setLoadingChats}
														setChatId={setChatId}
														setFieldBackField={setFieldBackField}
													/>
												);
											})}

									{Object.keys(chats).length === 0 && (
										<span className="sidebar__results__chats__noResult">
											{searchedKeyword.trim().length > 0 ? (
												<span>
													<Trans>
														No chats found for:{' '}
														<span className="searchOccurrence">{searchedKeyword}</span>
													</Trans>
												</span>
											) : (
												!isLoadingChats && <span>{t("You don't have any chats yet.")}</span>
											)}
										</span>
									)}
									{!canCreateChat && isRestaurant ? (
										<p
											style={{
												color: 'var(--color-font-grey)',
												fontSize: '14px',
												fontWeight: 600,
												textAlign: 'center',
												margin: '14px',
											}}
										>
											You can't create a new chat with the supplier
										</p>
									) : null}
								</div>

								{searchedKeyword.trim().length > 0 && getObjLength(contactResults) > 0 && (
									<>
										<h3>{t('Contacts')}</h3>
										<div className="sidebar__results__contacts">
											{Object.entries(contactResults).map((contactResult) => (
												<SidebarContactResult key={contactResult[0]} chatData={contactResult[1]} />
											))}
										</div>
									</>
								)}

								{searchedKeyword.trim().length > 0 && getObjLength(chatMessages) > 0 && (
									<>
										<h3>{t('Messages')}</h3>
										<div className="sidebar__results__messages">
											{Object.entries(chatMessages).map((message) => (
												<SearchMessageResult
													key={message[0]}
													waId={waId}
													messageData={message[1]}
													keyword={searchedKeyword}
													displaySender={true}
													onClick={(chatMessage) => goToMessage(chatMessage)}
												/>
											))}
										</div>
									</>
								)}
							</>
						) : (
							<CustomPermission
								icon={<LockIcon />}
								title="We are sorry..."
								paragraph="You do not have permission to view chats. Contact 
				an administrator to get permission."
								style={{ width: '90%', height: '50vh' }}
							/>
						)
					) : (
						<Loading />
					)}
				</div>

				<Fade in={isLoadingMoreChats} unmountOnExit>
					<div className="sidebar__loadingMore">
						<Zoom in={isLoadingMoreChats}>
							<div className="sidebar__loadingMore__wrapper">
								<CircularProgress size={28} />
							</div>
						</Zoom>
					</div>
				</Fade>

				{isContactsVisible && <StartChat onHide={() => setContactsVisible(false)} />}
				{/* 
				{isProfileVisible && (
					<BusinessProfile
						onHide={() => setProfileVisible(false)}
						displayEditBusinessProfile={displayEditBusinessProfile}
						setChangePasswordDialogVisible={setChangePasswordDialogVisible}
					/>
				)} */}

				{isUploadingMedia && !isMobileOnly && <UploadMediaIndicator />}

				{hasFailedMessages && (
					<RetryFailedMessages
						pendingMessages={pendingMessages}
						setPendingMessages={setPendingMessages}
						isSendingPendingMessages={isSendingPendingMessages}
						lastSendAttemptAt={lastSendAttemptAt}
						contactProvidersData={contactProvidersData}
						chats={chats}
					/>
				)}

				<BulkSendIndicator />

				<Menu
					anchorEl={anchorEl}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
					keepMounted
					PaperProps={{
						style: {
							height: '100px',
							boxShadow: '0px 10px 25px 0px #0000001A',
						},
					}}
					MenuListProps={{
						style: {
							height: '100%',
						},
					}}
					BackdropProps={{
						style: { backgroundColor: 'transparent' },
					}}
					open={Boolean(anchorEl)}
					onClose={hideMenu}
					elevation={3}
				>
					<MenuItem onClick={forceClearContactProvidersData}>{t('Refresh contacts')}</MenuItem>
					<MenuItem onClick={logOut} data-test-id="logout-button">
						<LogoutIcon style={{ marginRight: '6px' }} />
						{t('Logout')}
					</MenuItem>
				</Menu>

				{/* <Menu
					anchorEl={bulkMessageMenuAnchorEl}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
					keepMounted
					open={Boolean(bulkMessageMenuAnchorEl)}
					onClose={hideBulkMessageMenu}
					elevation={3}
				>
					<MenuItem onClick={showBulkSendTemplateDialog}>{t('Bulk send a template')}</MenuItem>
					<MenuItem onClick={showBulkSendTemplateViaCSVDialog}>
						{t('Bulk send template with CSV')}
					</MenuItem>
					<MenuItem onClick={showSendBulkVoiceMessageDialog}>
						{t('Bulk send a voice message')}
					</MenuItem>
				</Menu> */}

				<ChangePasswordDialog
					open={isChangePasswordDialogVisible}
					setOpen={setChangePasswordDialogVisible}
				/>

				{isNotificationsVisible && <Notifications onHide={() => setNotificationsVisible(false)} />}
			</div>
		</>
	);
};

export default Sidebar;
